export const filterQuery = (queryParams) => {
  const filteredQueryParams = { ...queryParams };
  // 键为数组
  for (const key of Object.keys(filteredQueryParams)) {
    // 判断键的值是否为空，为空删除
    if (filteredQueryParams[key] === '' || filteredQueryParams[key] === undefined || filteredQueryParams[key] === null) {
      delete filteredQueryParams[key];
    }
  }
  if (Object.keys(filteredQueryParams).length === 0) {
    return '';
  }else {
    return filteredQueryParams;
  }
}
//将配置文件中所有的温度点位的℃替换为℉，最大最小值经过计算转换成华氏度的值。最后返回处理过的配置文件
export const dealFjson = (jsonContent) => {
  console.log('jsonContent:', jsonContent);

  // 检查 jsonContent 和 addrs 是否有效
  if (!jsonContent || !Array.isArray(jsonContent.addrs)) {
    console.error('Invalid input: jsonContent.addrs is not an array');
    return jsonContent;
  }

  // 遍历所有的地址对象  
  jsonContent.addrs.forEach(addr => {  
    if (!Array.isArray(addr.attrs)) return; // 确保 attrs 是数组

    // 遍历每个地址下的 attrs 数组  
    addr.attrs.forEach(attr => {  
      // 检查 unit 字段  
      if (attr.unit === "℃") {  
        attr.unit = "℉";
        attr.unit_en = "℉";

        if (attr.rw === 'w' && attr.fix && !(attr.fix.max === 0 && attr.fix.min === 0)) {
          // 确保 max 和 min 是数字并转换单位
          if (typeof attr.fix.max === 'number') {
            attr.fix.max = attr.fix.max * 9 / 5 + 32;
          }
          if (typeof attr.fix.min === 'number') {
            attr.fix.min = attr.fix.min * 9 / 5 + 32;
          }
        }
      }
    });
  });

  return jsonContent;
};
